import type { QueryKey } from '@tanstack/react-query';

export const EXPENSES_PHOENIX_MAIN_KEY: QueryKey = ['expenses-phoenix'];

export const EXPENSES_PHOENIX_KEY = (params?: object): QueryKey =>
  params ? [...EXPENSES_PHOENIX_MAIN_KEY, params] : EXPENSES_PHOENIX_MAIN_KEY;

export const BUDGETS_PHOENIX_MAIN_KEY: QueryKey = ['budgets-phoenix'];

export const BUDGETS_PHOENIX_KEY = (params?: object): QueryKey =>
  params ? [...BUDGETS_PHOENIX_MAIN_KEY, params] : BUDGETS_PHOENIX_MAIN_KEY;

export const EXPENSE_SUBCATEGORIES_PHOENIX_KEY: QueryKey = [
  'expense-subcategories-phoenix',
];

export const EXPENSE_TAXES_PHOENIX_KEY: QueryKey = ['expense-taxes-phoenix'];

export const EXPENSE_BY_ID_KEY = (expenseId: string | undefined): QueryKey => [
  'expense-phoenix-by-id',
  expenseId,
];

export const EXPENSES_BY_CASH_GROUP_KEY = (
  cashTransactionGroupId: string | undefined
): QueryKey => ['expenses-phoenix-by-cash-group', cashTransactionGroupId];
